import { NotificationsPage } from "./NotificationsPage";

const pages = {
  NotificationsPage,
};
export default pages;
